import { CustomComponentProps } from "utils/types/general.types";
import UserPopover from "../feed-posts/UserPopover";
import { DemoUserListObject, DemoUserObject } from "assets/data/usersData";
import { avatar } from "utils/assets_exports/images";
import { useRef, useState } from "react";

export type UserDashboardPopover = CustomComponentProps & {
    user: DemoUserObject | DemoUserListObject;
    isOnline: boolean;
};
const UserDashboardPopover = ({
    user,
    isOnline,
    className,
    style
}: UserDashboardPopover) => {
    const [atTop, setAtTop] = useState(false);
    const [showPopOver, setShowPopOver] = useState(false);

    const popoverRef = useRef(null);
    const setPopoverPos = () => {
        // @ts-ignore
        const rect = popoverRef.current.getBoundingClientRect();
        // const left = rect.left - 50;

        const parentElBottom = rect.bottom;
        // get height of who can see the post modal
        const elHeight = 200;
        // get window height
        const windowHeight = window.innerHeight;
        // let top = 0;
        if (parentElBottom + elHeight - 10 >= windowHeight) {
            // make the elemnt above the btn
            setAtTop(true);
        } else {
            // make the element below the btn
            setAtTop(false);
        }
        setShowPopOver(true);
    };

    return (
        <div
            className={`image ${atTop && "top-pop-over"} pop-over-img relative dark:text-white ${className}`}
            style={style}
            onMouseEnter={setPopoverPos}
            onMouseLeave={() => setShowPopOver(false)}
        >
            <img
                src={user.url || avatar}
                className="avatar-img"
                data-user-popover="1"
                alt={`${user.name} Avatar`}
                ref={popoverRef}
            />
            {isOnline && <div className="online-dot"></div>}
            <div className={showPopOver ? "" : "hidden"}>
                <UserPopover user={user} />
            </div>
        </div>
    );
};

export default UserDashboardPopover;
